import React from "react";
import styles from './ovals.module.css';

const Oval = ({size, xPos, yPos}) => {
  return <div
    className={styles.oval}
    style={{
      width: size,
      height: size,
      top: yPos,
      left: xPos
    }}
  />;
};

export default function Ovals() {
    const ovals = [
    {
      size: 165,
      xPos: '27%',
      yPos: 92
    },
    {
      size: 42,
      xPos: '21%',
      yPos: 112
    },
    {
      size: 67,
      xPos: '24%',
      yPos: -10
    },
    {
      size: 103,
      xPos: '45%',
      yPos: 30
    },
    {
      size: 188,
      xPos: '59%',
      yPos: -50
    },
    {
      size: 67,
      xPos: '81%',
      yPos: 30
    },
    {
      size: 86,
      xPos: '70%',
      yPos: 139
    }
  ];

  return <>
    {ovals.map((oval, i) => <Oval
      key={i}
      size={oval.size}
      xPos={oval.xPos}
      yPos={oval.yPos}
      style={{zIndex: -1}}
    />)}
  </>
}
